$(document).ready(function() {
    var displayMessage = function(message, state, location){
        Message.target = location;
        Message.setMessage(message);
        Message.type = state;
        Message.postMessage();
    };

    // 2FA recovery modal
    $( '#two-factor-recovery-modal' ).modal({
        afterCloseModal : function() {

            // reset the recovery code field after closing the modal
            $( '#two-factor-recovery-modal' ).find( '#2FA-recovery-code' ).val( '' );
        },
        accept : function() {

            // add recovery code input
            var postString = 'recover2FA=1&recoveryCode=' + encodeURIComponent( $( '#2FA-recovery-code' ).val() );

            // add pageId
            postString += '&pageId=' + encodeURIComponent( $( '[name=pageId]' ).val() );

            $.fn.qpost({
                url : url( 'control/control_two_factor_login' ),
                data : postString,
                success : function( data ) {
                    if ( data && data.success ) {
                        window.location.reload( true );
                    } else if ( data && data.errors ) {
                        displayMessage( data.errors, 'error', $( '#two-factor-recovery-modal .ui-modal-message' ) );
                    }
                }
            });
        },
        decline : function() {
            $( '#two-factor-recovery-modal' ).data( 'qg_modal' ).closeModal();
        }
    });

    // validate login form
    $('.js-login-form').validate();

    // validate reset password form
    $('.js-reset-password-form').validate();

    // disable reset password submit button after clicking and validate
    $('.js-reset-password-form').on('submit', function(e){
        var $form = $(this),
            $submit = $form.find('.js-reset-password'),
            submitText = $submit.val(),
            errors = $form.data('qg_validation').validateForm();

        $submit.disabled = true;

        if ( errors.length ) {
            //display errors
            Message.target = $form;
            Message.post(errors, 'error');
            e.preventDefault();
            $submit.disabled = false;
        } else {
            //do nothing, we are good
        }
    });

    // open recovery modal
    $( '.js-trigger-2fa-recovery-modal' ).on( 'click', function( e ){
        e.preventDefault();
        $( '#two-factor-recovery-modal' ).data( 'qg_modal' ).showModal();
    });

    // add inline validation for checking valid global account on blur
    $('.js-validate-account').on('blur', function(){
        var $username = $(this),
            username = $username.val();

        // make sure it's a valid email
        if ( Validation.validateEmail(username) ){
            // perform ajax call
            $.fn.qpost({
                url : '/account/login/',
                data : {
                    verify_account : 1,
                    username : username
                },
                success : function(response) {
                    if ( response.success ) {
                        if ( response.accountId ) {
                            // if there is no first/last name, show those fields in the UI
                            if ( response.firstName == '' || response.lastName == '' ) {
                                $('.js-account-name-fields').slideDown(300);
                            } else {
                                // hide name fields
                                $('.js-account-name-fields').addClass('hide-content').removeAttr('style');
                            }
                        }
                    } else {
                        // hide name fields
                        $('.js-account-name-fields').addClass('hide-content').removeAttr('style');
                    }
                }
            });
        }
    });

    // toggle the password reset form
    $('.js-toggle-password-reset').on('click', function(){
        $(this).closest('.js-login-form-container').find('.ui-message').remove();

        $('.js-login-form').slideUp(300, function(){
            // show the reset password form
            $('.js-reset-password-form-login').removeClass('hide-content');
            // remove inline styles from login form and replace with CSS class for easier display
            $('.js-login-form').removeAttr('style').addClass('hide-content');
        });
    });

    $('.js-toggle-login-form').on('click', function(){
        $(this).closest('.js-login-form-container').find('.ui-message').remove();

        $('.js-reset-password-form-login').slideUp(300, function(){
            // show the login form
            $('.js-login-form').removeClass('hide-content');
            // remove inline styles from login form and replace with CSS class for easier display
            $('.js-reset-password-form-login').removeAttr('style').addClass('hide-content');
        });
    });

    $('.regenerate_reset').on('click', function() {
        $('.ui-message').remove();

        var username = $(this).attr('data-username');

        Message.target = $('.content');
        var postString = 'regenerate_reset&username=' + username;

        $.ajax({
            type: "POST",
            dataType: "json",
            data: postString,
            success: function(data) {
                if (data.success) {
                    $('.js-reset-password-form, .heading-beta').hide();

                    Message.post("A password reset email has been sent to " + username , 'success');
                } else if (data.errors) {
                    Message.post(data.errors, 'error');
                } else {
                    Message.post("An error has occurred. Please try again.", 'error');
                }
            },
            error: function() {
                Message.post("An error has occurred. Please try again.", 'error');
            }
        });
    });

    UI.focusOnLoad();
});